<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2021-09-15 11:40:44
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2022-11-18 17:17:52
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/nantong/dialog/justShow/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <dialogComp ref="dialog">
    <div class="box">
      <div class="title">
        {{ title }}
      </div>
      <div v-if="type == 'text'" class="content">
        <div v-for="(item, index) in html" :key="index">
          <div v-if="isString(item)">
            {{ item }}
          </div>
          <div v-else>
            <img
              v-for="(child, index2) in item"
              :src="child"
              :key="index2"
              alt=""
            />
          </div>
        </div>
      </div>
      <div v-else class="content">
          <div v-html="html"></div>
      </div>
    </div>
  </dialogComp>
</template>
<script>
import dialogComp from '@/components/dialog/index.vue';
export default {
  data() {
    return {
      html: '',
      title: '',
      type:''
    };
  },
  components: {
    dialogComp,
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    isString(val) {
      return typeof val == 'string';
    },
    close() {
      this.$refs.dialog.close();
    },
  },
};
</script>

<style lang="less" scoped="true">
.box {
  background: url(https://source.qunarzz.com/site/images/wns/20221118-shijianchen-tai-box.png)
    no-repeat;
  background-size: 100% auto;
  height: 400px;
  .title {
    position: relative;
    top: 20px;
    color: #333;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
  }
  .content {
    position: relative;
    top: 30px;
    height: 300px;
    padding: 20px;
    padding-top: 0;
    box-sizing: border-box;
    overflow-y: auto;
    /deep/ p {
      float: left !important;
      text-indent: 0 !important;
      color: #333 !important;
      font-size: 12px !important;
      line-height: 1.414 !important;
    }
    /deep/ * {
      font-size: 12px !important;
      background: transparent !important;
      color: #333 !important;
    }
    /deep/ img {
      width: 100% !important;
      height: inherit !important;
      display: block !important;
      margin-top: 8px !important;
      margin-bottom: 8px !important;
    }
  }
}
</style>